import { Box, Skeleton, Divider } from '@mui/material';

export default function PackagesFormSkeleton() {
  return (
    <Box padding={3}>
      {/* Header */}
      <Skeleton variant='text' width={200} height={32} sx={{ mb: 1 }} />
      <Skeleton variant='text' width={300} height={20} sx={{ mb: 3 }} />

      <Box component='form'>
        {/* Package Name and Public/Private Toggle */}
        <Box display='flex' alignItems='center' gap={2} mb={2}>
          <Skeleton variant='rectangular' height={40} sx={{ flex: 1 }} />
          <Box display='flex' flexDirection='row' alignItems='center' gap={1}>
            <Skeleton variant='text' width={60} height={20} />
            <Skeleton variant='rectangular' width={40} height={24} sx={{ borderRadius: 3 }} />
          </Box>
        </Box>

        {/* Base Price and Min Included */}
        <Box display='grid' gridTemplateColumns='1fr 1fr' gap={2} mb={2}>
          <Skeleton variant='rectangular' height={40} />
          <Skeleton variant='rectangular' height={40} />
        </Box>

        {/* Additional Minutes Cost */}
        <Skeleton variant='rectangular' height={40} sx={{ mb: 2 }} />

        <Divider sx={{ my: 2 }} />

        {/* Multilingual Charges Section */}
        <Box mb={3}>
          <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
            <Box>
              <Skeleton variant='text' width={180} height={20} />
              <Skeleton variant='text' width={250} height={16} />
            </Box>
            <Skeleton variant='rectangular' width={40} height={24} sx={{ borderRadius: 3 }} />
          </Box>
          <Skeleton variant='rectangular' height={40} />
        </Box>

        {/* Location Limit Section */}
        <Box mb={3}>
          <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
            <Box>
              <Skeleton variant='text' width={120} height={20} />
              <Skeleton variant='text' width={200} height={16} />
            </Box>
            <Skeleton variant='rectangular' width={40} height={24} sx={{ borderRadius: 3 }} />
          </Box>
          <Skeleton variant='rectangular' height={40} />
        </Box>

        {/* Integration Charges Section */}
        <Box mb={3}>
          <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
            <Box>
              <Skeleton variant='text' width={150} height={20} />
              <Skeleton variant='text' width={220} height={16} />
            </Box>
            <Skeleton variant='rectangular' width={40} height={24} sx={{ borderRadius: 3 }} />
          </Box>
          <Skeleton variant='rectangular' height={40} />
        </Box>

        {/* Storage Per GB Section */}
        <Box mb={3}>
          <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
            <Box>
              <Skeleton variant='text' width={120} height={20} />
              <Skeleton variant='text' width={180} height={16} />
            </Box>
            <Skeleton variant='rectangular' width={40} height={24} sx={{ borderRadius: 3 }} />
          </Box>
          <Skeleton variant='rectangular' height={40} />
        </Box>

        {/* Action Buttons */}
        <Box display='flex' justifyContent='flex-end' mt={3}>
          <Skeleton variant='rectangular' width={80} height={36} sx={{ mr: 1, borderRadius: 1 }} />
          <Skeleton variant='rectangular' width={80} height={36} sx={{ borderRadius: 1 }} />
        </Box>
      </Box>
    </Box>
  );
}
